import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, MenuItem, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { BLTypeData, BLTypeModel } from 'models/BLModel';


type BLTypeDialogProps = {
    type?: BLTypeModel,
} & ModalActionProps<BLTypeData>;

const BLTypeDialog = ({type, onFinish}: BLTypeDialogProps) => {
    const {t} = useTranslation();
    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = Object.fromEntries(new FormData(event.currentTarget).entries()) as any;

        onFinish(data);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    name="type"
                    label={t('type')}
                    fullWidth
                    select
                    required
                    defaultValue={type?.type || 'whole'}
                >
                    <MenuItem value="whole">whole</MenuItem>
                    <MenuItem value="fullbody">fullbody</MenuItem>
                    <MenuItem value="body">body</MenuItem>
                    <MenuItem value="cabin">cabin</MenuItem>
                    <MenuItem value="suspension">suspension</MenuItem>
                    <MenuItem value="frame">frame</MenuItem>
                    <MenuItem value="excavator_frame">excavator frame</MenuItem>
                    <MenuItem value="front">front</MenuItem>
                    <MenuItem value="rear">rear</MenuItem>
                    <MenuItem value="engine">engine</MenuItem>
                    <MenuItem value="engine_sus">engine + suspension</MenuItem>
                    <MenuItem value="cargo">cargo</MenuItem>
                    <MenuItem value="attachment">attachment</MenuItem>
                    <MenuItem value="boom">boom</MenuItem>
                    <MenuItem value="boom_cylinders">boom cylinders</MenuItem>
                </TextField>

                <TextField
                    autoFocus
                    name="name"
                    label={t('name')}
                    fullWidth
                    required
                    defaultValue={type?.name || ''}
                />

                <TextField
                    name="description"
                    label={t('description')}
                    fullWidth
                    required
                    multiline
                    rows={4}
                    defaultValue={type?.description || ''}
                />

            </DialogContent>

            <DialogActions>
                <Button type="submit">{type ? t('save') : t('add')}</Button>
            </DialogActions>
        </Box>
    );
};

export default BLTypeDialog;
